import styled from 'styled-components';
import { useIsDarkMode } from 'src/common/hooks/use-is-dark-mode';
const StyledAutoAnswerLabel = styled.div<{
  $isDarkMode: boolean;
  $isCorrect: boolean;
}>`
  background: ${({
  $isDarkMode
}) => $isDarkMode ? 'rgba(33, 44, 66, 1)' : 'rgba(249, 249, 251, 1)'};
  color: ${({
  theme,
  $isCorrect
}) => $isCorrect ? theme.colors.grey[600] : theme.colors.text.main};
  cursor: ${({
  $isCorrect
}) => $isCorrect && 'default'};
  padding: 1rem;
  border-radius: 0.5rem;
  width: 100%;
`;
export const AutoAnswerLabel = ({
  label,
  correct
}: {
  label: string;
  correct: boolean;
}) => {
  const isDarkMode = useIsDarkMode();
  return <StyledAutoAnswerLabel $isDarkMode={isDarkMode} $isCorrect={correct} data-sentry-element="StyledAutoAnswerLabel" data-sentry-component="AutoAnswerLabel" data-sentry-source-file="auto-answer-label.tsx">
      {label}
    </StyledAutoAnswerLabel>;
};